import React, { Component } from 'react';
import './CartItem.scss';
import plus from '../../../img/plus.svg';
import minus from '../../../img/minus.svg';

class CartItem extends Component {
  render() {
    const { id, name, price, total, count } = this.props.item;
    const { addCount, subCount, removeItem } = this.props.value;
    return (
      <div className='cart-item-row'>
        <div className='cart-item-row__item-price'>
          <p className='bold'>{name}</p>
          <p>${price.toFixed(2)}</p>
        </div>
        <div className='cart-item-row__change-count'>
          <img
            className='btn cart-btn count-btn'
            onClick={() => {
              return subCount(id);
            }}
            src={minus}
            alt='click to decrease item count'
          />
          <p className='cart-item-row__count bold'>{count}</p>
          <img
            className='btn cart-btn count-btn'
            onClick={() => {
              return addCount(id);
            }}
            src={plus}
            alt='click to increase item count'
          />
          <button
            className='btn cart-btn remove-btn'
            onClick={() => removeItem(id)}
          >
            Remove
          </button>
        </div>
        <p className='cart-item-row__total italic'>
          Item total: <span className='bold'>${total.toFixed(2)}</span>
        </p>
      </div>
    );
  }
}

export default CartItem;
